import { render } from "./rigsbq.vue?vue&type=template&id=d79898f0"
import script from "./rigsbq.vue?vue&type=script&lang=js"
export * from "./rigsbq.vue?vue&type=script&lang=js"
script.render = render

export default script